export enum CampaignComponentTabs {
  Configure = 'configure',
  Target = 'target',
  Design = 'design',
  Schedule = 'schedule',
}
